import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiConfig } from '../../core/api-config';
import { LoginResponseModel } from '../../core/models';
import { AuthSessionService } from '../auth-session/auth-session.service';

// Service for customer/admin authentication.
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  // Inject HTTP and session.
  constructor(private http: HttpClient, private session: AuthSessionService) {}

  // Customer login.
  customerLogin(email: string, password: string): Observable<LoginResponseModel> {
    return this.http.post<LoginResponseModel>(`${ApiConfig.baseUrl}/authentication/customer-login`, { email, password })
      .pipe(tap(x => this.session.setCurrentUser(x)));
  }

  // Admin login.
  adminLogin(email: string, password: string): Observable<LoginResponseModel> {
    return this.http.post<LoginResponseModel>(`${ApiConfig.baseUrl}/authentication/admin-login`, { email, password })
      .pipe(tap(x => this.session.setCurrentUser(x)));
  }

  // Customer registration.
  registerCustomer(model: any): Observable<LoginResponseModel> {
    return this.http.post<LoginResponseModel>(`${ApiConfig.baseUrl}/authentication/register-customer`, model)
      .pipe(tap(x => this.session.setCurrentUser(x)));
  }

  // Logout.
  logout(): void {
    this.session.clear();
  }
}
